import { DEFAULT_PAGE_SIZE } from '../constants/pagination';
export const genericTableDefaultState = {
  search: '',
  teams: [],
  users: [],
  categories: [],
  tools: [],
  certificationStatuses: [],
  playlists: [],
  dueDate: undefined,
  completedDate: undefined,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  sortBy: 'NAME',
  sortOrder: 'ASC',
  isUserPinned: undefined,
  assignedByMe: undefined
};
export const certificationProfileActiveTableDefaultState = {
  sortBy: 'EXPIRES_AT',
  sortOrder: 'ASC'
};
export const certificationProfileExpiredTableDefaultState = {
  sortBy: 'EXPIRES_AT',
  sortOrder: 'DESC'
};
export const certificationProfileInProgressTableDefaultState = {
  sortBy: 'PROGRESS',
  sortOrder: 'DESC'
};
export const certificationsIndexTableDefaultState = {
  sortBy: 'ACTIVE',
  sortOrder: 'DESC'
};
export const teamMembersTableDefaultState = {
  sortBy: 'ACTIVE',
  sortOrder: 'DESC',
  isUserPinned: true
};
export const certificationsByTeamActiveTableDefaultState = {
  sortBy: 'EXPIRES_AT',
  sortOrder: 'ASC'
};
export const certificationsByTeamInProgressTableDefaultState = {
  sortBy: 'PROGRESS',
  sortOrder: 'DESC'
};
export const certificationsByTeamExpiredTableDefaultState = {
  sortBy: 'EXPIRES_AT',
  sortOrder: 'DESC'
};
export const playlistsTableDefaultState = {
  sortBy: 'PLAYLIST_NAME',
  sortOrder: 'ASC'
};